import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import NoSsr from '@material-ui/core/NoSsr'
import ControlTooltip from './ControlTooltip'
import ControlClose from './ControlClose'
import LetteringsIcon from '../../../../icons/LetteringsIcon'
import {letteringsSelector, drawControlPopupSelector} from '../../selectors'
import {addObjectsToCanvas} from '../../AC/add-objects-to-canvas'

const POPUP_NAME = 'LETTERINGS'

Letterings.propTypes = {
    letterings: PropTypes.array,
    addObjectsToCanvas: PropTypes.func,
}

function Letterings(props) {
    const addLettering = (params) => () => {
        props.addObjectsToCanvas(params)
    }

    const {letterings, drawControlPopup} = props

    return (
        <NoSsr>
            <ControlTooltip
                popupName={POPUP_NAME}
                icon={<LetteringsIcon />}
                title={'Надписи'}
            />
            {drawControlPopup === POPUP_NAME && (
                <div className="panel-popup">
                    <div className="panel-popup__title">
                        Выбери надпись и редактируй
                    </div>
                    <div className="letterings panel-popup__content">
                        {letterings.map(({id, type, preview, original}) => (
                            <div
                                key={id}
                                className="letterings__item"
                                onClick={addLettering({type, original})}
                            >
                                <img loading="lazy" src={preview} />
                            </div>
                        ))}
                    </div>
                    <ControlClose />
                </div>
            )}
        </NoSsr>
    )
}

const mapStateToProps = (state) => ({
    letterings: letteringsSelector(state),
    drawControlPopup: drawControlPopupSelector(state),
})

const mapDispatchToProps = {
    addObjectsToCanvas,
}

export default connect(mapStateToProps, mapDispatchToProps)(Letterings)
